import React from 'react';
import { styled } from '@linaria/react';
import { Icon } from '@daedalus/atlas/Icon';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { ContentHotel } from '@findhotel/sapi/dist/types/packages/core/src/types';
import { SelectedElement } from './TrackLocationClick';
type PropsTypes = {
  hotel: ContentHotel;
};
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1k40pef",
  propsAsIs: false
});
const LocationDetailsWrapper = /*#__PURE__*/styled('div')({
  name: "LocationDetailsWrapper",
  class: "l4bvnvz",
  propsAsIs: false
});
const LocationAddressIconWrapper = /*#__PURE__*/styled('div')({
  name: "LocationAddressIconWrapper",
  class: "lsyog45",
  propsAsIs: false
});
const _exp4 = /*#__PURE__*/() => Icon;
const LocationAddressIcon = /*#__PURE__*/styled(_exp4())({
  name: "LocationAddressIcon",
  class: "lulofx9",
  propsAsIs: true
});
const LocationSummaryLoader = () => <SkeletonLoader height={16} width={120} marginTop={0} />;
export const LocationAddress = ({
  hotel
}: PropsTypes) => {
  return <Wrapper data-id={SelectedElement.CompleteAddress}>
      {hotel ? <>
          <LocationAddressIconWrapper>
            <LocationAddressIcon name="Pin" colorPath="content.neutral.c600" size="sm" />
          </LocationAddressIconWrapper>
          <LocationDetailsWrapper>
            {hotel.displayAddress}
          </LocationDetailsWrapper>
        </> : <LocationSummaryLoader />}
    </Wrapper>;
};

require("./LocationAddress.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./LocationAddress.tsx");